import type ScrollViewContentContainerStyles from './types';

// On the web, we can use flex to fit the content to fit the viewport within a ScrollView.
const scrollViewContentContainerStyles: ScrollViewContentContainerStyles = (styles) => styles.flex1;

export default scrollViewContentContainerStyles;
